import React from 'react';
import Flagship from '../../core/flagship';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../../actions/appActions';
import NavBar from './NavBar';
import {Menu, Icon} from 'semantic-ui-react'
import { Link } from 'react-router';
import AlertContainer from 'react-alert'

// This is a class-based component because the current
// version of hot reloading won't hot reload a stateless
// component at the top-level.
class App extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.componentWillReceiveProps.bind(this);
    }

    componentWillMount() {

        let token = localStorage.getItem("flagshipToken");
        if ( token !== null ) {
            this.props.actions.checkToken(token);
        } else if
        (
            this.props.router.routes[1].path !== "user/setup/*" &&
            this.props.router.routes[1].path !== "user/reset/*"
        ){
            Flagship.redirect("/login");
        }

        let resizeWindow = this.props.actions.resizeWindow;

        // Handle window resize events
        window.addEventListener("resize",this.debounce(function(){
            resizeWindow(Math.max(document.documentElement.clientWidth, window.innerWidth || 0));
        }));
    }

    componentWillReceiveProps(nextProps) {
        let actions = this.props.actions;

        if (
            nextProps.notification !== this.props.notification &&
            nextProps.notification.show &&
            nextProps.notification.message) {
            this.msg.show(nextProps.notification.message, {
                type: nextProps.notification.type,
                onClose: actions.clearNotification
            });
        }
    }

    debounce(func){
        let timer;
        return function(event){
            if(timer) clearTimeout(timer);
            timer = setTimeout(func,200,event);
        };
    }

    render() {

        let alertOptions = {
            offset: 14,
            position: 'bottom right',
            theme: 'light',
            time: 5000,
            transition: 'scale'
        };

        return (

            <div id="flagship-app-container"
               className={ (this.props.sidebarNavActive ? "sidebar-nav-open " : "sidebar-nav-closed ") + (this.props.isLoggedIn ? "user-logged-in" : "user-logged-out")}>

                <div className="flagship-notifications">
                    <AlertContainer
                     ref={(msg) => { this.msg = msg; return true; }}
                     {...alertOptions}
                    />
                </div>

            {this.props.isLoggedIn ?
            <div>
                <div>
                    <NavBar
                      openMenu={Flagship.toggleSidebarNav}
                      sidebarNavActive={this.props.sidebarNavActive}
                    />
                </div>

                <div id="sidebar-menu">
                    <Menu className={this.props.sidebarNavActive ? "nav-open" : "nav-closed"}
                        icon='labeled'
                        id="sidebar-menu-inner"
                        vertical
                    >
                        <Menu.Item as={Link} to="/" name='home'>
                            <Icon name='home' />
                            Home
                        </Menu.Item>
                        <Menu.Item  as={Link} to="/clients" name='clients'>
                            <Icon name='briefcase' />
                            Clients
                        </Menu.Item>
                        <Menu.Item  as={Link} to="/rfps" name='rfps'>
                            <Icon name='dollar' />
                            RFPs
                        </Menu.Item>
                        <Menu.Item  as={Link} to="/ios" name='ios'>
                            <Icon name='rocket' />
                            IOs
                        </Menu.Item>
                        <Menu.Item  as={Link} to="/search" name='search'>
                            <Icon name='search' />
                            Search
                        </Menu.Item>
                    </Menu>
                </div>
            </div>
            : null }
              <div id="flagship-main">
                <div id="flagship-main-inner">
                  {this.props.children}
                </div>
              </div>
            </div>

        );
    }
}

App.propTypes = {
    actions: PropTypes.object,
    isLoggedIn: PropTypes.bool,
    userPhoto: PropTypes.string,
    username: PropTypes.string,
    children: PropTypes.element,
    errors: PropTypes.array,
    notification: PropTypes.object
};


function mapStateToProps(state) {
    return {
        isLoggedIn: state.main.isLoggedIn,
        username: state.main.username,
        userPhoto: state.main.userPhoto,
        sidebarNavActive: state.main.sidebarNavActive,
        errors: state.main.errors,
        notification: state.main.notification
    };
}


function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/components/ui/App.js